import React, { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import layoutContext from "./layoutContext";
import { OutVector } from "../assets/svg/index";
import ConfirmationModel from "../components/common/ConfirmationModel";
import SidebarDropDown from "../components/common/SidebarDropDown";
import {
  affirmations,
  audio,
  garden,
  movement,
  nutrition,
  recipes,
  tips,
  user,
  video,
  Logo,
  bell,
  tester,
  subscription,
  section,
} from "../assets/images";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAsideOpen } = useContext(layoutContext);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);

  const dummyPermissions = {
    permission_list: [
      {
        title: "Users",
        path: "dashboard",
        editpath: "edit-user",
        icon_path: user,
        is_show: 1,
      },
      {
        title: "Nutritions",
        path: "nutrition",
        icon_path: nutrition,
        is_show: 1,
        subMenu: [
          {
            title: "Nutrition Recipes",
            path: "nutrition-recipes",
            addpath: "add-edit-recipe",
            icon_path: recipes,
            is_show: 1,
          },
          {
            title: "Nutrition Tips",
            path: "nutrition-tips",
            addpath: "add-edit-tip",
            icon_path: tips,
            is_show: 1,
          },
        ],
      },
      {
        title: "Movements",
        path: "movement",
        addpath: "add-edit-movement",
        icon_path: movement,
        is_show: 1,
      },
      {
        title: "Communal Garden",
        path: "communal-garden",
        addpath: "add-edit-communal-garden",
        icon_path: garden,
        is_show: 1,
      },
      {
        title: "Audios",
        path: "audio",
        addpath: "add-edit-audio",
        icon_path: audio,
        is_show: 1,
      },
      {
        title: "Videos",
        path: "video",
        addpath: "add-edit-video",
        icon_path: video,
        is_show: 1,
      },
      {
        title: "Affirmations",
        path: "affirmations",
        addpath: "add-edit-affirmation",
        icon_path: affirmations,
        is_show: 1,
      },
      {
        title: "Subscriptions",
        path: "subscription",
        icon_path: subscription,
        is_show: 1,
        subMenu: [
          {
            title: "Manage Free Users",
            path: "user-tester",
            addpath: "user-tester",
            icon_path: tester,
            is_show: 1,
          },
        ],
      },
      {
        title: "Push Notifications",
        path: "push-notification",
        addpath: "add-notification",
        icon_path: bell,
        is_show: 1,
      },
      {
        title: "Sections",
        path: "section",
        addpath: "add-section",
        icon_path: section,
        is_show: 1,
      },
    ],
  };
  // Log Out Clear
  const logOutClear = () => {
    sessionStorage.clear();
    navigate("/login");
  };

  return (
    <>
      <aside
        className={`${
          isAsideOpen ? "w-[16rem]" : "md:w-[5rem] w-0"
        } fixed top-0 z-[99] md:relative flex flex-col justify-between md:overflow-visible overflow-hidden transition-all border-r border-gray h-[calc(100vh-4rem)] bg-white`}
      >
        <div className="h-full">
          <div className="flex flex-col items-center justify-center px-5 py-2 gap-x-4 border-b border-gray relative bg-navTheme">
            <div
              className={`origin-left font-medium text-xl duration-250 overflow-hidden flex  items-center cursor-pointer justify-center ${
                isAsideOpen ? "w-[12rem] h-16" : "w-16 h-11"
              }`}
              onClick={() => navigate("/")}
            >
              <img src={Logo} alt="Logo" className="w-10 h-10 rounded-xl" />
            </div>
            {process.env.REACT_APP_MODE === "dev" ? (
              <span className="text-xs font-semibold text-white">
                Development
              </span>
            ) : (
              <span className="text-xs font-semibold text-white">
                Production
              </span>
            )}
          </div>
          <ul
            className={`h-[calc(100vh-12.9rem)] overflow-x-hidden  ${
              isAsideOpen ? "overflow-y-auto" : "overflow-visible"
            }  `}
          >
            {dummyPermissions?.permission_list.map((menu, index) => {
              const filteredSubMenu = menu?.subMenu?.filter(
                (sub) => sub?.is_show !== 0,
              );

              if (filteredSubMenu?.length) {
                return (
                  <SidebarDropDown
                    key={index}
                    isAsideOpen={isAsideOpen}
                    menu={{ ...menu, subMenu: filteredSubMenu }}
                  />
                );
              }

              return (
                <li key={index} className="group aside-links tooltipBlock">
                  <button
                    className={`flex items-center relative z-[99999] m-0 py-2 gap-x-4 h-auto w-full rounded-lg transition duration-200
      ${
        !isAsideOpen
          ? "px-2 hover:translate-x-0 hover:bg-navTheme/15 my-1 justify-center"
          : "hover:translate-x-1 px-4"
      }
      ${
        location.pathname ===
          `/${menu.path === "dashboard" ? "" : menu.path}` ||
        (menu.addpath && location.pathname.startsWith(`/${menu.addpath}`))
          ? "bg-navTheme/15 text-themeBtn font-medium"
          : "hover:text-black"
      }
    `}
                    onClick={() =>
                      navigate(`${menu.path === "dashboard" ? "/" : menu.path}`)
                    }
                  >
                    <div className="max-w-5 max-h-5 w-full">
                      <img
                        src={menu?.icon_path ?? Logo}
                        className="w-full h-full object-contain"
                        alt="icon"
                      />
                      {/* add text here is development take a mode from */}
                    </div>

                    {isAsideOpen && (
                      <p className="origin-left font-normal text-base font-figtree">
                        {menu.title}
                      </p>
                    )}
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
        {/* Log Out */}
        <div className="p-4 flex items-center border-t border-sideBorder">
          <button
            className={`flex items-center relative z-[99999] ${
              !isAsideOpen
                ? "px-2 hover:translate-x-0 hover:bg-navTheme/20 my-1 justify-center"
                : "hover:translate-x-1 px-4 "
            } gap-x-4 h-auto  hover:text-black w-full rounded-lg transition duration-200`}
            onClick={() => setIsLogoutModalOpen(true)}
          >
            <OutVector />
            <p
              className={`origin-left font-medium duration-250 flex  items-center  ${
                !isAsideOpen && "hidden"
              }   `}
            >
              Log Out
            </p>
            {!isAsideOpen && (
              <div
                id="tooltip"
                className="right absolute top-[20%] left-[55px] text-xs whitespace-nowrap font-semibold -z-[100] hidden"
              >
                <div className="absolute w-0 h-0 border-transparent border-solid tooltip-arrow border-r-transparent" />
                <div className="tooltip-label py-1 px-2 text-white bg-black rounded-[4px] text-center max-w-[180px]">
                  <OutVector />
                </div>
              </div>
            )}
          </button>
        </div>
      </aside>

      {/* Logout Confirmation Modal */}
      {isLogoutModalOpen && (
        <ConfirmationModel
          onConfirm={() => {
            logOutClear();
            setIsLogoutModalOpen(false);
          }}
          onClose={() => setIsLogoutModalOpen(false)}
          confirmText="Logout"
        />
      )}
    </>
  );
};

export default Sidebar;
